import { type TFunction } from 'i18next';

import { confirmDialog } from '@/ui_v3';

/**
 * 공개 동의를 묻는 대상.
 *
 * - `quiz`: 비공개 퀴즈가 공개 폴더로 들어가 공개된다(담기·이동).
 * - `folder`: 이 폴더를 공개하면서 안의 비공개 퀴즈가 공개된다(폴더 수정의 공개 전환).
 */
export type PublishConsentSubject = 'quiz' | 'folder';

/**
 * 서버가 `QUIZSET_FOLDER_PUBLISH_CONFIRM_REQUIRED` 로 막았을 때 띄우는 확인창. `withPublishConfirm` 의 `ask` 로 넘긴다.
 *
 * 묻는지 여부는 서버가 정하고 여기서는 문구만 고른다. 확인/취소 라벨은 다이얼로그 기본값이다.
 */
export const askPublishConsent = (
  t: TFunction<['common']>,
  subject: PublishConsentSubject = 'quiz',
) =>
  confirmDialog.openAsync(
    subject === 'folder'
      ? {
          header: { title: t('common:folder.edit.publishConfirm.title') },
          body: t('common:folder.edit.publishConfirm.description'),
          confirmIntent: 'alternative',
        }
      : {
          header: { title: t('common:folderSave.publishConfirm.title') },
          body: t('common:folderSave.publishConfirm.description'),
        },
  );
